<app-customer-dropdown-list
  [data]="customerData()"
  [isLoading]="isLoading()"
  [selectedId]="selectedCustomerId"
  [allowCustomerCreation]="false"
  [allowCustomerEdit]="false"
  [placeholder]="filter?.placeholder"
  [styleClass]="'ng-select-sm'"
  (searchTrigger)="onSearchTrigger($event)"
  (selectedChange)="onCustomerSelected($event)"
  (clearTrigger)="onClearTrigger()"
  data-cy="orders-filter-customer-dropdown"
></app-customer-dropdown-list>
